import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { orpc } from "@/orpc/client";
import { PartnersPage } from "@/pages/partners/PartnersPage";
import { PartnersPageSkeleton } from "@/pages/partners/PartnersPageSkeleton";

const SearchParamsSchema = z.object({
	create: z.boolean().optional(),
});

export const Route = createFileRoute("/_app/partners/")({
	validateSearch: SearchParamsSchema,
	head: () => ({
		meta: [{ title: "Partners - Biteasy" }],
	}),
	loader: async ({ context: { queryClient } }) =>
		queryClient.ensureQueryData(orpc.partners.list.queryOptions({ input: {} })),
	pendingComponent: PartnersPageSkeleton,
	component: PartnersPage,
});
